<template>
	<div class="main">
		<loader></loader>
		<header class="page-title">
			<h2>Editing {{ loophole['en'].title }}</h2>
			<div class="ml-auto">
				<a @click.prevent="saveLoophole" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="card">
			<header class="card-header language-list">
				<lang-selector></lang-selector>
			</header>
			<div class="card-body">
				<div class="form-group">
					<label for="title">Loophole Title<sup class="text-danger">*</sup></label>
					<input id="title" type="text" v-model="loophole[clickedLang].title" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
					<p class="input-error" v-if="errors.errors.title">{{ errors.errors.title }}</p>
				</div>
				<div class="form-group">
					<label for="content">Loophole Content<sup class="text-danger">*</sup></label>
					<editor
							v-model="loophole[clickedLang].content"
							id="content"
							:api-key="tinyMCEApiKey"
							:init="tinyMCEConfig"
							:disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale"
					/>
					<p class="input-error" v-if="errors.errors.content">{{ errors.errors.content }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import Errors from "../../Utils/Errors";

export default {
	name: "LoopholeEdit",
	props: {
		data: {
			type: Object
		},
		dataId: {
			type: Number
		}
	},
	data() {
		return {
			loophole: this.data,
			loopholeId: this.dataId,
			clickedLang: this.$defaultLanguage.locale,

			tinyMCEApiKey: this.$tinyMCEApiKey,
			tinyMCEConfig: this.$tinyMCEConfig,

			userRoles: this.$currentUserRoles,
			defaultLocale: this.$defaultLanguage.locale,

			errors: new Errors(),
		}
	},
	created() {
		let vm = this;

		// When setActiveStatus method ran, change selected data in form fields
		/* From LangSelector */
		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});
	},
	methods: {
		saveLoophole: function () {
			let vm = this;
			eventBus.$emit('onLoaderStart');

			axios.put('/api/' + vm.$selectedSite.slug + '/loophole/' + vm.loopholeId, vm.loophole)
					.then(function (response) {
						if (response) {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.success('Loophole updated.', 'Success');
						} else {
							eventBus.$emit('onLoaderFinish');
							vm.$toastr.error('Loophole update failed.', 'Error');
						} // if
					}).catch(function (e) {
				vm.$toastr.error('Loophole update failed.', 'Error');
				vm.errors.record(e.response.data);
			});
		}
	}
}
</script>

<style scoped>

</style>
